<template>
  <CreateModal type="defaultServiceValues" ref="createModal">
    <v-row class="mw-1200 mx-auto" justify="center">
      <v-col cols="12" sm="5">
        <v-form class="mx-auto" ref="defaultServiceValuesForm" lazy-validation>
          <ContractTypeAndCity />
          <RepeatServiceValues v-show="showDefaultValuesForm" />
        </v-form>
      </v-col>
      <v-col cols="12" sm="7" v-if="hasServiceContracts">
        <TableServiceValues />
        <div class="text-right mt-8">
          <v-btn
            @click="submit"
            :loading="isLoading"
            color="primary"
            elevation="0"
            x-large
          >
            {{ $t('defaultServiceValues.actions.create') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <EditDefaultServiceValuesModal />
  </CreateModal>
</template>

<script>
import CreateModal from '@/components/app/CreateModal'
import ContractTypeAndCity from './formFieldsCreate/ContractTypeAndCity'
import RepeatServiceValues from './formFieldsCreate/RepeaterServiceValues'
import TableServiceValues from './tableFieldsCreate/TableServiceValues'
import EditDefaultServiceValuesModal from './modals/EditDefaultServiceValuesModal'

import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'DefaultServiceValuesForm',

  components: {
    CreateModal,
    ContractTypeAndCity,
    RepeatServiceValues,
    TableServiceValues,
    EditDefaultServiceValuesModal,
  },

  data() {
    return {
      hasAtLeastContractType: false,
      hasServiceContracts: false,
    }
  },

  watch: {
    defaultServiceValuesFields() {
      this.checkServiceContractsLength()
    },
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'showDefaultValuesForm',
      'defaultServiceValuesFields',
    ]),
  },

  methods: {
    ...mapActions(['createDefaultServiceValues']),
    ...mapMutations(['setDefaultServiceValuesStepsCurr']),

    submit() {
      this.createDefaultServiceValues()
    },

    toggleFormDefaultValues(status) {
      this.hasAtLeastContractType = status
    },

    checkServiceContractsLength() {
      const length = this.defaultServiceValuesFields.service_contracts.length

      if (length >= 1) this.hasServiceContracts = true
      else this.hasServiceContracts = false
    },

    openModal() {
      this.$refs?.createModal?.openCreateModal()
    }
  },
}
</script>
